import Grid2 from "@mui/material/Unstable_Grid2";
import CommodityForm1 from "./CommodityForm1";
import CommodityForm2 from "./CommodityForm2";
import { useDomesticMarketSpreadPriceContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceContext";
import { useDomesticMarketSpreadPriceCategoryContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceCategoryContext";
import useResponsive from "../../../../../components/hooks/useResponsive";
import AddToFavoritesButton from "../../../../../components/favorite/AddToFavoritesButton";
import { BarChartOutlined } from "@mui/icons-material";
import Loading from "../../../../../components/loader/Loading";
import { sendData } from "../../../../../lib/dashboard/actions";
import { mutate } from "swr";

const CategoryForm = () => {
  const { isMd } = useResponsive();

  const { isFavoritesValidation } = useDomesticMarketSpreadPriceContext();
  const {
    inputCategoryValues1,
    inputCategoryValues2,
    isChartLoading,
    handleShowChart,
  } = useDomesticMarketSpreadPriceCategoryContext();

  const body = {
    // commodity 1
    industry1_id: inputCategoryValues1.industry?.id,
    field1_id: inputCategoryValues1.field?.id,
    group1_id: inputCategoryValues1.group?.id,
    company1_id: inputCategoryValues1.company?.id,
    commodity1_id: inputCategoryValues1.commodity?.id,
    // commodity 2
    industry2_id: inputCategoryValues2.industry?.id,
    field2_id: inputCategoryValues2.field?.id,
    group2_id: inputCategoryValues2.group?.id,
    company2_id: inputCategoryValues2.company?.id,
    commodity2_id: inputCategoryValues2.commodity?.id,
  };
  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/domestic-ratio/category");
    if (res.status === 200) await mutate("/favorite/domestic-ratio/category");
  };

  const isDisabled = [
    inputCategoryValues1.industry?.id,
    inputCategoryValues1.field?.id,
    inputCategoryValues2.industry?.id,
    inputCategoryValues2.field?.id,
  ].every(Boolean);

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <CommodityForm1 />
      </Grid2>
      <Grid2 xs={12}>
        <CommodityForm2 />
      </Grid2>
      <Grid2 xs={10} md={6}>
        <button
          style={{ height: "43px" }}
          onClick={() => handleShowChart(body)}
          className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
          disabled={!isDisabled || isChartLoading}
        >
          {isChartLoading ? (
            <Loading color={"#fff"} />
          ) : (
            <>
              نمایش
              <BarChartOutlined />
            </>
          )}
        </button>
      </Grid2>
      <Grid2 xs={2} md={6}>
        <AddToFavoritesButton
          text={isMd && "افزودن به علاقمندی ها"}
          style={{ height: "44px" }}
          isDisabled={!isDisabled}
          onClick={handleAddToFavorite}
          isLoading={isFavoritesValidation}
        />
      </Grid2>
    </Grid2>
  );
};

export default CategoryForm;
